"use client";
import { T, useTextLocale, tl } from "@/components/t";
import { withBase } from "@/lib/with-base";

export default function ProfileError({ error, reset }: { error: Error; reset: () => void }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-6">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-50">
        <svg className="h-8 w-8 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
      <h2 className="text-lg font-bold text-foreground"><T de={"Profil konnte nicht geladen werden"} en={"Profile could not be loaded"} /></h2>
      <p className="text-sm text-muted-foreground text-center max-w-md">
        <T de={"Beim Laden deines Profils ist ein Fehler aufgetreten. Deine Daten sind sicher, versuche es erneut."} en={"Something went wrong loading your profile. Your data is safe, please try again."} />
      </p>
      <div className="flex gap-3">
        <button onClick={reset} className="rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary/90">
          <T de="Erneut versuchen" en="Try again" />
        </button>
        <button onClick={() => { window.location.href = withBase("/"); }} className="rounded-xl border border-border px-5 py-2.5 text-sm font-medium text-foreground hover:bg-secondary">
          Zum Dashboard
        </button>
      </div>
    </div>
  );
}
